export default "__VITE_ASSET__d2d42616__"